import { EvaluationFormValues } from './EvaluationModal.types'

const isFilledValue = (value: unknown) =>
  value !== null && value !== undefined && (typeof value !== 'string' || value.trim() !== '')

export const formatPercentValue = (value: number | null, digits = 1) => {
  if (value === null || value === undefined) return '--'

  return value.toLocaleString('pt-BR', {
    minimumFractionDigits: digits,
    maximumFractionDigits: digits
  })
}

export const formatSalesValue = (value: number | null) => {
  if (value === null || value === undefined) return '--'

  if (value >= 1000) {
    return `${(value / 1000).toLocaleString('pt-BR', {
      maximumFractionDigits: 1
    })} mil`
  }

  return value.toLocaleString('pt-BR')
}

export const formatPresenceValue = (value: number | null) => {
  if (value === null || value === undefined) return '--'

  if (value <= 1) return 'Fraca'

  if (value === 2) return 'Médio'

  return 'Forte'
}

export const getSliderValue = (value: number | number[] | null | undefined): number | null => {
  const normalized = Array.isArray(value) ? value[0] : value

  return normalized ?? null
}

export const compactObject = <T extends Record<string, unknown>>(obj: T) =>
  Object.fromEntries(Object.entries(obj).filter(([, value]) => isFilledValue(value)))

export const buildEvaluationPayload = (values: EvaluationFormValues) => {
  if (values.target === 'priority') {
    return {
      priority: compactObject({
        score: values.priority_score,
        agreement: values.priority_agreement,
        new_priority: values.priority_agreement === 'disagree' ? values.priority_new : null,
        comment: values.priority_agreement === 'disagree' ? values.priority_comment : null
      }),
      tab: {},
      competitors: []
    }
  }

  const tab = compactObject({
    fidelity: values.tab_fidelity,
    fee: values.tab_fee,
    approval: values.tab_approval
  })

  const competitors =
    values.competitors
      ?.filter((competitor) => competitor.enabled)
      .map((competitor) =>
        compactObject({
          competitor_id: competitor.id,
          price: competitor.price,
          coupon: competitor.coupon,
          entry: competitor.entry,
          commission_store: competitor.commission_store,
          commission_sales: competitor.commission_sales,
          fair: competitor.fair,
          presence: competitor.presence,
          less_bureaucracy: competitor.less_bureaucracy,
          platform_score: competitor.platform_score,
          comment: competitor.comment
        })
      ) ?? []

  return {
    priority: {},
    tab,
    competitors
  }
}
